import { AxiosInstance } from 'axios';
import {
    FundsTransferChange,
    FundsTransferFilter,
    FundsTransferTable,
    UnloadSetting,
    UnloadSettingCreate,
    UnloadSettingUpdate,
} from 'models/api/fundsTransfer';
import ResTable from 'models/api/table';

const controller = '/fundstransfers';

export const getFundsTransferList = async (axios: AxiosInstance, params?: FundsTransferFilter) => {
    const response = await axios.get<ResTable<FundsTransferTable>>(controller, {
        params: { ...params },
    });
    return response.data;
};

export const changeFundsTransfer = async (axios: AxiosInstance, item: FundsTransferChange) =>
    await axios.put(controller + `/${item.id}`, item);

export const getFundsTransferExcel = async (axios: AxiosInstance, params: FundsTransferFilter) => {
    const { data } = await axios.get<Blob>(controller + '/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};

export const downloadFile = async (axios: AxiosInstance, id: string) => {
    const response = await axios.get<Blob>(controller + '/file/' + id, {
        responseType: 'arraybuffer',
    });
    return response.data;
};

export const getFundsTransferSettings = async (axios: AxiosInstance) => {
    const { data } = await axios.get<UnloadSetting[]>(controller + '/settings');
    return data;
};

export const unloadRegistry = async (axios: AxiosInstance, ids: number[]) => {
    return await axios.post(controller, ids);
};

export const addFundsTransferSetting = async (axios: AxiosInstance, item: UnloadSettingCreate) => {
    return await axios.post<UnloadSetting>(controller + '/settings', item);
};

export const changeFundsTransferSetting = async (
    axios: AxiosInstance,
    item: UnloadSettingUpdate
) => {
    return await axios.put<UnloadSetting>(controller + `/settings/`, item);
};

export const deleteFundsTransferSetting = async (axios: AxiosInstance, id: number | string) => {
    return await axios.delete(controller + `/settings/${id}`);
};
